/** Location state key set when sending a guest to `/login` so they return afterwards */
export interface LoginRedirectState {
  from?: string
}

/**
 * Where to go after a successful login. Only same-origin paths are honoured
 * (rejects `//host` and absolute URLs) to avoid open redirects.
 */
export function getPostLoginRedirect(state: unknown): string {
  const from = (state as LoginRedirectState | null)?.from
  if (typeof from !== 'string' || !from.startsWith('/') || from.startsWith('//') || from.startsWith('/\\')) {
    return '/'
  }
  return from
}
